import { ExternalLink } from 'lucide-react';
import akSite from '../assets/images/ak-site.png';
import cwSite from '../assets/images/cw-site.png';
import cwSiteV2 from '../assets/images/cw-site-v2.png';
import mulliganSite from '../assets/images/mulligan-site.png';
// import cwFlyer from '../assets/images/cw-flyer.png';
import jjCard from '../assets/images/jj-card.png';
import jjFlyer from '../assets/images/jj-flyer.png';
import alCard from '../assets/images/al-card.png';

const projects = [
  {
    slug: "Portfolio_Alexandre_Kotowicz_React",
    title: "Portfolio Alexandre Kotowicz",
    type: "Site Web",
    description: "Portfolio interactif pour un développeur de jeux vidéo en recherche d'emploi au Canada",
    category: "web",
    color: "bg-cyan-400",
    image: akSite
  },
  {
    slug: "Clip_Web_Site",
    title: "Site web : Clip Web",
    type: "Site Web",
    description: "Site vitrine professionnel développé avec React et optimisé SEO",
    category: "web",
    color: "bg-violet-600",
    image: cwSite
  },
  {
    slug: "Mulligan_TCG_Site_Web",
    title: "Site web Mulligan TCG",
    type: "Site Web",
    description: "Plateforme communautaire pour les joueurs de TCG en Normandie",
    category: "web",
    color: "bg-orange-600",
    image: mulliganSite
  },
  // {
  //   slug: "Clip_Web_Flyer_Digital",
  //   title: "Flyer numérique Clip Web",
  //   type: "Design",
  //   description: "Support de communication digital pour promouvoir mes services freelance",
  //   category: "design",
  //   color: "bg-yellow-400",
  //   image: cwFlyer
  // },
  {
    slug: "Clip_Web_Site_V2",
    title: "Nouveau Site Clip Web",
    type: "Site Web",
    description: "Site vitrine professionnel développé avec React et optimisé SEO",
    category: "web",
    color: "bg-yellow-400",
    image: cwSiteV2
  },
  {
    slug: "JJ_Detailing_Carte_Visite",
    title: "Carte de visite JJ Detailing",
    type: "Design",
    description: "Identité professionnelle pour une entreprise de detailing automobile",
    category: "design",
    color: "bg-cyan-400",
    image: jjCard
  },
  {
    slug: "JJ_Detailing_Flyer",
    title: "Flyer JJ Detailing",
    type: "Design",
    description: "Support print recto/verso pour les services de detailing automobile",
    category: "design",
    color: "bg-violet-600",
    image: jjFlyer
  },
  {
    slug: "AL_Batiment_Carte_Visite",
    title: "Carte de visite AL Bâtiment",
    type: "Design",
    description: "Création complète d'identité visuelle pour une entreprise du bâtiment",
    category: "design",
    color: "bg-orange-600",
    image: alCard
  }
];

export { projects };

export function Portfolio({ onProjectClick }) {
  return (
    <section id="projets" className="bg-[#F0F8FF] py-10 px-4 sm:py-16 sm:px-6 md:py-20 relative overflow-hidden">
      {/* Decorative stars */}
      <div
        className="hidden md:block absolute top-10 left-10 w-8 h-8 bg-yellow-400"
        style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)' }}
      />
      <div
        className="hidden md:block absolute bottom-20 right-20 w-10 h-10 bg-orange-600"
        style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)' }}
      />

      <div className="max-w-7xl mx-auto relative">
        {/* Titre corrigé responsive : pas inline-block sur mobile */}
        <div className="bg-black text-white p-4 sm:p-6 mb-8 md:mb-12 border-4 border-black shadow-[5px_5px_0px_0px_rgba(255,200,0,1)] sm:shadow-[8px_8px_0px_0px_rgba(255,200,0,1)] md:shadow-[12px_12px_0px_0px_rgba(255,200,0,1)]">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black leading-tight">
            MES PROJETS
            <span className="block text-yellow-400 text-xs min-[400px]:text-sm sm:text-2xl md:text-3xl mt-1">
              7 RÉALISATIONS · 4 SITES WEB · 3 DESIGNS
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 md:gap-8">
          {projects.map((project, index) => (
            <div key={index} className="group relative">
              <div className="flex sm:block bg-white border-4 border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] sm:shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] hover:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] sm:hover:shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:translate-x-1 hover:translate-y-1 transition-all overflow-hidden">
                {/* Browser bar */}
                <div className="hidden sm:flex bg-gray-200 border-b-4 border-black p-2 items-center gap-2">
                  <div className="flex gap-1.5">
                    <div className="w-3 h-3 bg-red-500 rounded-full border-2 border-black" />
                    <div className="w-3 h-3 bg-yellow-400 rounded-full border-2 border-black" />
                    <div className="w-3 h-3 bg-green-500 rounded-full border-2 border-black" />
                  </div>
                  <div className="flex-1 bg-white border-2 border-black h-6 rounded" />
                </div>

                {/* Color area */}
                <div className={`${project.color} w-[38%] min-h-[7.5rem] shrink-0 sm:w-auto sm:min-h-0 sm:h-40 md:h-44 flex items-center justify-center border-r-4 sm:border-r-0 sm:border-b-4 border-black p-2 sm:p-4`}>
                  <img 
                    src={project.image} 
                    alt={project.title}
                    className="max-w-full max-h-24 sm:max-h-full object-contain"
                  />
                </div>

                {/* Info */}
                <div className="p-3 sm:p-5 bg-white min-w-0 flex-1 flex flex-col justify-center sm:block">
                  <h3 className="text-base sm:text-lg font-black mb-1 leading-tight sm:leading-tight">{project.title}</h3>
                  <p className="font-bold text-xs sm:text-sm mb-3 sm:mb-4 text-gray-700 leading-snug sm:leading-5">{project.description}</p>
                  <button
                    onClick={() => onProjectClick && onProjectClick(project.slug)}
                    className="self-start flex items-center gap-2 font-black text-xs sm:text-sm bg-black text-white px-3 py-2 sm:px-4 border-2 border-black shadow-[3px_3px_0px_0px_rgba(0,0,0,0.3)] sm:shadow-[4px_4px_0px_0px_rgba(0,0,0,0.3)] hover:shadow-none hover:translate-x-1 hover:translate-y-1 transition-all"
                  >
                    VOIR LE PROJET
                    <ExternalLink className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                  </button>
                </div>
              </div>

              {(index === 2 || index === 3) && (
                <div className="absolute -top-3 -right-2 sm:-right-3 bg-orange-600 text-white px-2 sm:px-3 py-0.5 sm:py-1 font-black text-[10px] sm:text-xs border-[3px] sm:border-4 border-black rotate-12 shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] sm:shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
                  NOUVEAU !
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Polka dots - masqués sur mobile pour éviter overflow */}
      <div className="hidden xl:grid absolute top-40 right-1/4 grid-cols-3 gap-2">
        {[...Array(9)].map((_, i) => (
          <div key={i} className="w-3 h-3 bg-violet-600 rounded-full" />
        ))}
      </div>
    </section>
  );
}
